import { FunctionComponent, useContext, useState } from 'react';
import { useRouter } from 'next/router';

import { CookieKeys } from 'types/cookies';
import { Routes } from 'types/routes';

import { Types } from 'models/UserAgree';

import { getProvider } from 'services/Cookies';

import { createProfessional } from 'requests/leads';

import LocaleContext from 'components/context/Locale';
import Button, { ButtonElements, ButtonLayouts, ButtonStyles } from 'components/layout/Button';
import Input from 'components/layout/forms/Input';
import Modal from 'components/layout/Modal';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageArticleSectionAccessBar: FunctionComponent<Props> = ({ state, articleHref, onSuccess }) => {
    const articleAcess: boolean = getProvider().get(CookieKeys.ArticleAccess) ?? false;

    if (articleAcess) {
        onSuccess && onSuccess();
        return null;
    };

    const router = useRouter();
    const [inputValue, setInputValue] = useState<string>(state.profile?.email ?? null);
    const [error, setError] = useState<string>(null);

    const localeContext = useContext(LocaleContext);
    const translations = localeContext?.translations?.componentArticleAccessBar;
    const { headline, subheadline, image, input, buttonLabel, legend } = translations;

    const onSumbit = async () => {
        await createProfessional({
            email: inputValue,
            userAgrees: [{
                type: Types.Professional,
                value: true,
                content: subheadline,
            }],
        })
            .then(() => {
                getProvider().set(CookieKeys.ArticleAccess, true);
                onSuccess && onSuccess();
                router.push(articleHref);
            })
            .catch(error => {
                const errorObj = error?.payload?.validationErrors;
                setError(errorObj['email']);
            });
    };

    return (
        <StyledComponent className="public-page-article-section-access-bar">
            <Modal
                onClose={() => router.push(Routes.PublicBlog)}
                forbidOnClose
            >
                <div className="col col-left">
                    <div className="col-header">
                        <div
                            className="headline"
                            dangerouslySetInnerHTML={{ __html: headline }}
                        />
                        <div
                            className="subheadline"
                            dangerouslySetInnerHTML={{ __html: subheadline }}
                        />
                    </div>
                    <div className="col-content">
                        <Input
                            name="firstName"
                            label={input?.label}
                            placeholder={input?.placeholder}
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value);
                                setError(null);
                            }}
                            error={error}
                        />
                        <Button
                            className="cta"
                            style={ButtonStyles.Gold}
                            layout={ButtonLayouts.Block}
                            element={ButtonElements.Button}
                            disabled={!inputValue}
                            onClick={() => onSumbit()}
                        >
                            {buttonLabel}
                        </Button>
                        <div
                            className="legend"
                            dangerouslySetInnerHTML={{ __html: legend }}
                        />
                    </div>
                </div>
                <div className="col col-right">
                    <div
                        className="element-image"
                        style={{ backgroundImage: `url(${image})` }}
                    />
                </div>
            </Modal>
        </StyledComponent>
    );
};

export default PublicPageArticleSectionAccessBar;
